import Filter from 'bad-words';

/**
 * Profanity filter for user-provided names (currently the Peace Torch
 * first-name capture; reusable for other open-text identity fields).
 *
 * Library: bad-words@3 — ~600 English profanity terms. We allowlist a small
 * set of legitimate first names that the library catches as false positives
 * (Dick, Fanny, Willy, Cock — all real names). Add to ALLOWLIST_NAMES as
 * more come up.
 *
 * If we ever see meaningful l33t-speak bypass attempts (e.g. "Sh1t" is
 * already caught but "$h!t" isn't), consider swapping to the `obscenity`
 * library which handles those better.
 *
 * Imported by BOTH the BefriendSheet pre-prompt (client-side, for
 * immediate UX feedback) and `backend.setGuestName` (server-side, the
 * actual gate). Clients can be bypassed; the server is authoritative.
 */
const ALLOWLIST_NAMES = ['dick', 'fanny', 'willy', 'cock'];

const filter = new Filter();
filter.removeWords(...ALLOWLIST_NAMES);

export function isCleanName(name: string): boolean {
  const trimmed = name.trim();
  if (!trimmed) return true; // empty is "clean" — separate empty-check elsewhere
  return !filter.isProfane(trimmed);
}
